<template>
  <div class="card-item" :class="{ '-active': isCardFlipped }">
    <div class="card-item__side -front">
      <div
        class="card-item__focus"
        :class="{ '-active': focusElementStyle }"
        :style="focusElementStyle"
        ref="focusElement"
      ></div>
      <div class="card-item__cover">
        <img
          v-if="currentCardBackground"
          :src="currentCardBackground"
          class="card-item__bg"
        />
      </div>
      <div class="card-item__wrapper">
        <div class="card-item__top">
          <img
            src="https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/chip.png"
            class="card-item__chip"
          />
          <div class="card-item__type">
            <transition name="slide-fade-up">
              <img
                :src="
                  'https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/' +
                  cardType +
                  '.png'
                "
                v-if="cardType"
                :key="cardType"
                alt
                class="card-item__typeImg"
              />
            </transition>
          </div>
        </div>
        <!-- CVV on front of card for Amex -->
        <div v-if="cardType === 'amex'">
          <div class="card-item-cvv-amex">
            <span v-for="(n, $index) in labels.cardCvv" :key="$index">*</span>
          </div>
        </div>
        <label
          :for="fields.cardNumber"
          class="card-item__number"
          :ref="fields.cardNumber"
        >
          <template>
            <span v-for="(n, $index) in currentPlaceholder" :key="$index">
              <transition name="slide-fade-up">
                <div
                  class="card-item__numberItem"
                  v-if="getIsNumberMasked($index, n)"
                >
                  *
                </div>
                <div
                  class="card-item__numberItem"
                  :class="{ '-active': n.trim() === '' }"
                  :key="currentPlaceholder"
                  v-else-if="visualNumber.length > $index"
                >
                  {{ visualNumber[$index] }}
                </div>
                <div
                  class="card-item__numberItem"
                  :class="{ '-active': n.trim() === '' }"
                  v-else
                  :key="currentPlaceholder + 1"
                >
                  {{ n }}
                </div>
              </transition>
            </span>
          </template>
        </label>
        <div class="card-item__content">
          <label
            :for="fields.cardName"
            class="card-item__info"
            :ref="fields.cardName"
          >
            <div class="card-item__holder">{{ $t('card.cardHolder') }}</div>
            <transition name="slide-fade-up">
              <div
                class="card-item__name"
                v-if="labels.cardName.length"
                key="1"
              >
                <transition-group name="slide-fade-right">
                  <span
                    class="card-item__nameItem"
                    v-for="(n, $index) in labels.cardName.replace(
                      /\s\s+/g,
                      ' '
                    )"
                    :key="$index + 1"
                    >{{ n }}</span
                  >
                </transition-group>
              </div>
              <div class="card-item__name" v-else key="2">
                {{ $t('card.fullName') }}
              </div>
            </transition>
          </label>
          <div class="card-item__date" ref="cardDate">
            <label :for="fields.cardMonth" class="card-item__dateTitle">{{
              $t('card.expires')
            }}</label>
            <label :for="fields.cardMonth" class="card-item__dateItem">
              <transition name="slide-fade-up">
                <span v-if="labels.cardMonth" :key="labels.cardMonth">{{
                  labels.cardMonth
                }}</span>
                <span v-else key="2">{{ $t('card.MM') }}</span>
              </transition>
            </label>
            /
            <label class="card-item__dateItem">
              <transition name="slide-fade-up">
                <span v-if="labels.cardYear" :key="labels.cardYear">{{
                  labels.cardYear
                }}</span>
                <span v-else key="2">{{ $t('card.YY') }}</span>
              </transition>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="card-item__side -back">
      <div class="card-item__cover">
        <img
          v-if="currentCardBackground"
          :src="currentCardBackground"
          class="card-item__bg"
        />
      </div>
      <div class="card-item__band"></div>
      <div class="card-item__cvv">
        <div class="card-item__cvvTitle">CVV</div>
        <div class="card-item__cvvBand">
          <span v-for="(n, $index) in labels.cardCvv" :key="$index">*</span>
        </div>
        <div class="card-item__type">
          <img
            :src="
              'https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/' +
              cardType +
              '.png'
            "
            v-if="cardType"
            class="card-item__typeImg"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

  @Component
  export default class CardWidget extends Vue {
    @Prop({
      default: () => {
        return {
          cardName: '',
          cardNumber: '',
          cardNumberNotMask: '',
          cardMonth: '',
          cardYear: '',
          cardCvv: '',
        };
      },
    })
    labels: any;
    @Prop({
      default: () => {
        return {
          cardNumber: 'v-card-number',
          cardName: 'v-card-name',
          cardMonth: 'v-card-month',
          cardYear: 'v-card-year',
          cardCvv: 'v-card-cvv',
        };
      },
    })
    fields: any;
    @Prop() isCardNumberMasked: boolean;
    @Prop({ default: true }) randomBackgrounds: boolean;
    @Prop({ default: null }) currentFocus;
    backgroundImage: [string, any];
    focusElementStyle = null;
    isFocused = false;
    isCardFlipped = false;
    amexCardPlaceholder = '#### ###### #####';
    dinersCardPlaceholder = '#### ###### ####';
    defaultCardPlaceholder = '#### #### #### ####';
    currentPlaceholder = '';

    async created() {}

    mounted() {
      this.changePlaceholder();
    }

    get visualNumber() {
      let raw = this.labels.cardNumber,
        placeholder = this.currentPlaceholder,
        final = '';

      if (!raw) return '';

      let j = 0;
      for (let i = 0; i < placeholder.length; i++) {
        const pC = placeholder[i];
        if (pC !== ' ') {
          final += raw[j++];
          if (j === raw.length) break;
        } else final += ' ';
      }

      return final;
    }

    @Watch('currentFocus')
    onCurrentFocusChanged(newVal, oldVal) {
      if (oldVal) {
        this.isCardFlipped = this.currentFocus === this.fields.cardCvv;
        this.isFocused = false;
      }
      if (newVal) {
        this.isFocused = true;
        if (
          this.currentFocus === this.fields.cardYear ||
          this.currentFocus === this.fields.cardMonth
        ) {
          this.currentFocus = 'cardDate';
        } else {
          this.currentFocus = this.currentFocus;
        }
        if (this.cardType !== 'amex')
          this.isCardFlipped = this.currentFocus === this.fields.cardCvv;
      }
      if (this.currentFocus) {
        this.changeFocus();
      } else {
        this.focusElementStyle = null;
      }
    }

    @Watch('cardType')
    onCardTypeChanged() {
      this.changePlaceholder();
    }

    get cardType() {
      let number = this.labels.cardNumber;

      if (!number) return '';

      let re = new RegExp('^4');
      if (number.match(re) != null) return 'visa';

      re = new RegExp('^(34|37)');
      if (number.match(re) != null) return 'amex';

      re = new RegExp('^5[1-5]');
      if (number.match(re) != null) return 'mastercard';

      re = new RegExp('^6011');
      if (number.match(re) != null) return 'discover';

      re = new RegExp('^62');
      if (number.match(re) != null) return 'unionpay';

      re = new RegExp('^9792');
      if (number.match(re) != null) return 'troy';

      re = new RegExp('^3(?:0([0-5]|9)|[689]\\d?)\\d{0,11}');
      if (number.match(re) != null) return 'dinersclub';

      re = new RegExp('^35(2[89]|[3-8])');
      if (number.match(re) != null) return 'jcb';

      return ''; // default type
    }

    get currentCardBackground() {
      if (this.randomBackgrounds && !this.backgroundImage) {
        // TODO will be optimized
        let random = Math.floor(Math.random() * 25 + 1);
        return `https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/${random}.jpeg`;
      } else if (this.backgroundImage) {
        return this.backgroundImage;
      } else {
        return null;
      }
    }

    changeFocus() {
      let target = <HTMLElement>this.$refs[this.currentFocus];
      this.focusElementStyle = target
        ? {
            width: `${target.offsetWidth}px`,
            height: `${target.offsetHeight}px`,
            transform: `translateX(${target.offsetLeft}px) translateY(${target.offsetTop}px)`,
          }
        : null;
    }

    getIsNumberMasked(index, n) {
      return (
        index > 4 &&
        index < 14 &&
        this.labels.cardNumber &&
        this.labels.cardNumber.length > index &&
        n.trim() !== '' &&
        this.isCardNumberMasked
      );
    }

    changePlaceholder() {
      if (this.cardType === 'amex') {
        this.currentPlaceholder = this.amexCardPlaceholder;
      } else if (this.cardType === 'dinersclub') {
        this.currentPlaceholder = this.dinersCardPlaceholder;
      } else {
        this.currentPlaceholder = this.defaultCardPlaceholder;
      }
      this.$nextTick(() => {
        this.changeFocus();
      });
    }
  }
</script>

<style scoped lang="scss">
  body {
    background: #ddeefc;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 16px;
  }
  * {
    box-sizing: border-box;
    &:focus {
      outline: none;
    }
  }
  .wrapper {
    min-height: 100vh;
    display: flex;
    padding: 50px 15px;
    @media screen and (max-width: 700px), (max-height: 500px) {
      flex-wrap: wrap;
      flex-direction: column;
    }
  }

  .card-item {
    width: 310px;
    height: 190px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    z-index: 2;

    @media screen and (max-width: 480px) {
    }

    @media screen and (max-width: 360px) {
      height: 180px;
    }

    &.-active {
      .card-item__side {
        &.-front {
          transform: perspective(1000px) rotateY(180deg) rotateX(0deg)
            rotateZ(0deg);
        }
        &.-back {
          transform: perspective(1000px) rotateY(0) rotateX(0deg) rotateZ(0deg);
          // box-shadow: 0 20px 50px 0 rgba(81, 88, 206, 0.65);
        }
      }
    }

    &__focus {
      position: absolute;
      z-index: 3;
      border-radius: 5px;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      transition: all 0.35s cubic-bezier(0.71, 0.03, 0.56, 0.85);
      opacity: 0;
      pointer-events: none;
      overflow: hidden;
      border: 2px solid rgba(255, 255, 255, 0.65);

      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        background: rgb(8, 20, 47);
        height: 100%;
        border-radius: 5px;
        filter: blur(25px);
        opacity: 0.5;
      }

      &.-active {
        opacity: 1;
      }
    }

    &__side {
      border-radius: 15px;
      overflow: hidden;
      // box-shadow: 3px 13px 30px 0px rgba(11, 19, 41, 0.5);
      box-shadow: 0 6px 20px 0 rgba(14, 42, 90, 0.35);
      transform: perspective(2000px) rotateY(0deg) rotateX(0deg) rotate(0deg);
      transform-style: preserve-3d;
      transition: all 0.8s cubic-bezier(0.71, 0.03, 0.56, 0.85);
      backface-visibility: hidden;
      height: 100%;

      &.-back {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        transform: perspective(2000px) rotateY(-180deg) rotateX(0deg)
          rotate(0deg);
        z-index: 2;
        padding: 0;
        // background-color: #2364d2;
        // background-image: linear-gradient(
        //   43deg,
        //   #4158d0 0%,
        //   #8555c7 46%,
        //   #2364d2 100%
        // );
        height: 100%;

        .card-item__cover {
          transform: rotateY(-180deg);
        }
      }
    }
    &__bg {
      max-width: 100%;
      display: block;
      max-height: 100%;
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
    &__cover {
      height: 100%;
      position: absolute;
      height: 100%;
      background-color: #1c1d27;
      background-image: linear-gradient(147deg, #354fce 0%, #0c296b 74%);
      left: 0;
      top: 0;
      width: 100%;
      border-radius: 15px;
      overflow: hidden;
      &:after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(6, 2, 29, 0.45);
      }
    }

    &__top {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin-bottom: 15px;
      padding: 0 10px;

      @media screen and (max-width: 480px) {
      }
      @media screen and (max-width: 360px) {
        margin-bottom: 15px;
      }
    }

    &__chip {
      width: 50px;
      @media screen and (max-width: 480px) {
      }
      @media screen and (max-width: 360px) {
        width: 40px;
      }
    }

    &__type {
      height: 40px;
      max-width: 90px;
      position: relative;
      display: flex;
      margin-left: auto;
      width: 100%;

      @media screen and (max-width: 480px) {
      }
      @media screen and (max-width: 360px) {
        height: 30px;
      }
    }

    &__typeImg {
      max-width: 100%;
      object-fit: contain;
      max-height: 100%;
      object-position: top right;
    }

    &__info {
      color: #fff;
      width: 100%;
      max-width: calc(100% - 85px);
      padding: 10px;
      font-weight: 500;
      display: block;

      cursor: pointer;

      @media screen and (max-width: 480px) {
      }
    }

    &__holder {
      opacity: 0.7;
      font-size: 12px;
      margin-bottom: 5px;
      @media screen and (max-width: 480px) {
      }
    }

    &__wrapper {
      font-family: 'Source Code Pro', monospace;
      padding: 20px 10px;
      position: relative;
      z-index: 4;
      height: 100%;
      text-shadow: 7px 6px 10px rgba(14, 42, 90, 0.8);
      user-select: none;
      @media screen and (max-width: 480px) {
      }
    }

    &__name {
      font-size: 16px;
      line-height: 1;
      white-space: nowrap;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      text-transform: uppercase;
      @media screen and (max-width: 480px) {
      }
    }
    &__nameItem {
      display: inline-block;
      min-width: 8px;
      position: relative;
    }

    &__number {
      font-weight: 500;
      line-height: 1;
      color: #fff;
      font-size: 21px;
      margin-bottom: 0px;
      padding: 10px 10px;
      display: inline-block;
      cursor: pointer;

      @media screen and (max-width: 480px) {
      }

      @media screen and (max-width: 360px) {
        font-size: 19px;
        margin-bottom: 10px;
        padding: 10px 10px;
      }
    }

    &__numberItem {
      display: inline-block;
      width: 13px;

      &.-active {
        width: 16px;
      }

      @media screen and (max-width: 360px) {
        width: 12px;

        &.-active {
          width: 8px;
        }
      }
    }

    &__content {
      color: #fff;
      display: flex;
      align-items: flex-start;
    }

    &__date {
      flex-wrap: wrap;
      font-size: 16px;
      margin-left: auto;
      padding: 10px;
      display: inline-flex;
      width: 80px;
      white-space: nowrap;
      flex-shrink: 0;
      cursor: pointer;

      @media screen and (max-width: 480px) {
      }
    }

    &__dateItem {
      position: relative;
      span {
        width: 22px;
        display: inline-block;
      }
    }

    &__dateTitle {
      opacity: 0.7;
      font-size: 12px;
      padding-bottom: 5px;
      width: 100%;

      @media screen and (max-width: 480px) {
      }
    }
    &__band {
      background: rgba(0, 0, 19, 0.8);
      width: 100%;
      height: 50px;
      margin-top: 20px;
      position: relative;
      z-index: 2;
      @media screen and (max-width: 480px) {
      }
      @media screen and (max-width: 360px) {
        height: 40px;
        margin-top: 10px;
      }
    }

    &__cvv {
      text-align: right;
      position: relative;
      z-index: 2;
      padding: 15px;
      .card-item__type {
        opacity: 0.7;
      }

      @media screen and (max-width: 360px) {
        padding: 10px 15px;
      }
    }
    &__cvvTitle {
      padding-right: 10px;
      font-size: 15px;
      font-weight: 500;
      color: #fff;
      margin-bottom: 5px;
    }
    &__cvvBand {
      background: #fff;
      height: 40px;
      margin-bottom: 20px;
      text-align: right;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 10px;
      color: #1a3b5d;
      font-size: 18px;
      border-radius: 4px;
      box-shadow: 0px 10px 20px -7px rgba(32, 56, 117, 0.35);

      @media screen and (max-width: 480px) {
      }

      @media screen and (max-width: 360px) {
        margin-bottom: 15px;
      }
    }
  }

  .card-list {
    margin-bottom: -120px;

    @media screen and (max-width: 480px) {
    }
  }

  .card-input {
    margin-bottom: 20px;
    position: relative;
    &__label {
      font-size: 14px;
      margin-bottom: 5px;
      font-weight: 500;
      color: #1a3b5d;
      width: 100%;
      display: block;
      user-select: none;
    }
    &__input {
      width: 100%;
      height: 50px;
      border-radius: 5px;
      box-shadow: none;
      border: 1px solid #ced6e0;
      transition: all 0.3s ease-in-out;
      font-size: 18px;
      padding: 5px 15px;
      background: none;
      color: #1a3b5d;
      font-family: 'Source Sans Pro', sans-serif;

      &:hover,
      &:focus {
        border-color: #3d9cff;
      }

      &:focus {
        box-shadow: 0px 10px 20px -13px rgba(32, 56, 117, 0.35);
      }
      &.-select {
        -webkit-appearance: none;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAeCAYAAABuUU38AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAUxJREFUeNrM1sEJwkAQBdCsngXPHsQO9O5FS7AAMVYgdqAd2IGCDWgFnryLFQiCZ8EGnJUNimiyM/tnk4HNEAg/8y6ZmMRVqz9eUJvRaSbvutCZ347bXVJy/ZnvTmdJ862Me+hAbZCTs6GHpyUi1tTSvPnqTpoWZPUa7W7ncT3vK4h4zVejy8QzM3WhVUO8ykI6jOxoGA4ig3BLHcNFSCGqGAkig2yqgpEiMsjSfY9LxYQg7L6r0X6wS29YJiYQYecemY+wHrXD1+bklGhpAhBDeu/JfIVGxaAQ9sb8CI+CQSJ+QmJg0Ii/EE2MBiIXooHRQhRCkBhNhBcEhLkwf05ZCG8ICCOpk0MULmvDSY2M8UawIRExLIQIEgHDRoghihgRIgiigBEjgiFATBACAgFgghEwSAAGgoBCBBgYAg5hYKAIFYgHBo6w9RRgAFfy160QuV8NAAAAAElFTkSuQmCC');
        background-size: 12px;
        background-position: 90% center;
        background-repeat: no-repeat;
        padding-right: 30px;
      }
    }
    &__eye {
      display: inline-flex;
      position: absolute;
      width: 1em;
      height: 1em;
      font-size: 24px;
      border-radius: 50%;
      top: 35px;
      right: 10px;
      opacity: 0.75;
      color: #8c9cae;
      cursor: pointer;
      padding: 0;
      background: none;
      display: inline-flex;
      border: 2px solid currentColor;
      box-shadow: none;
      transition: all 0.3s ease-in-out;

      &:before {
        content: '';
        position: absolute;
        background: white;
        width: 0.35em;
        height: 0.35em;
        top: 6px;
        left: 6px;
        z-index: 2;
        border-radius: 50%;
        transform: scale(0.1);
        opacity: 0;
        transition: all 0.3s ease-in-out;
        transition-delay: 0.1s;
      }

      &:after {
        content: '';
        position: absolute;
        top: 3px;
        left: 3px;
        background: currentColor;
        width: 0.6em;
        height: 0.6em;
        border-radius: 50%;
        transform: scale(0.1);
        opacity: 0;
        transition: all 0.3s ease-in-out;
      }

      &:hover:not(:disabled),
      &.-active:not(:disabled) {
        color: #2364d2;
        opacity: 1;
      }

      &.-active {
        &::before,
        &::after {
          transform: scale(1);
          opacity: 1;
        }
      }

      &:disabled {
        cursor: not-allowed;
        opacity: 0.4;
      }
    }
  }

  .slide-fade-up-enter-active {
    transition: all 0.25s ease-in-out;
    transition-delay: 0.1s;
    position: relative;
  }
  .slide-fade-up-leave-active {
    transition: all 0.25s ease-in-out;
    position: absolute;
  }
  .slide-fade-up-enter {
    opacity: 0;
    transform: translateY(15px);
    pointer-events: none;
  }
  .slide-fade-up-leave-to {
    opacity: 0;
    transform: translateY(-15px);
    pointer-events: none;
  }

  .slide-fade-right-enter-active {
    transition: all 0.25s ease-in-out;
    transition-delay: 0.1s;
    position: relative;
  }
  .slide-fade-right-leave-active {
    transition: all 0.25s ease-in-out;
    position: absolute;
  }
  .slide-fade-right-enter {
    opacity: 0;
    transform: translateX(10px) rotate(45deg);
    pointer-events: none;
  }
  .slide-fade-right-leave-to {
    opacity: 0;
    transform: translateX(-10px) rotate(45deg);
    pointer-events: none;
  }

  .github-btn {
    position: absolute;
    right: 40px;
    bottom: 50px;
    text-decoration: none;
    padding: 15px 25px;
    border-radius: 4px;
    box-shadow: 0px 4px 30px -6px rgba(36, 52, 70, 0.65);
    background: #24292e;
    color: #fff;
    font-weight: bold;
    letter-spacing: 1px;
    font-size: 16px;
    text-align: center;
    transition: all 0.3s ease-in-out;

    @media screen and (min-width: 500px) {
      &:hover {
        transform: scale(1.1);
        box-shadow: 0px 17px 20px -6px rgba(36, 52, 70, 0.36);
      }
    }

    @media screen and (max-width: 700px) {
      position: relative;
      bottom: auto;
      right: auto;
      margin-top: 20px;

      &:active {
        transform: scale(1.1);
        box-shadow: 0px 17px 20px -6px rgba(36, 52, 70, 0.36);
      }
    }
  }

  .card-item-cvv-amex {
    color: #fff;
    margin-top: -6%;
    font-size: 27px;
    font-weight: 500;
    position: absolute;
    left: 78%;
  }
</style>
